import {dehydrate, QueryClient} from '@tanstack/react-query';
import React from 'react';

import {disallowSlug, RENDER_MODES} from '@udemy/nextjs-core';

import {DemoFormFeature} from 'src/features/demo-form';
import {getCompactTranslations} from 'src/lib-server/locale.server';
import {FOUR_HOURS} from 'src/lib/constants';
import {getStaticAppContext} from 'src/pages/api/context.api';
import {AppContextData} from 'src/types/page-props';

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

export const getStaticProps = disallowSlug(async ({locale}) => {
    locale = locale as string;
    const translations = await getCompactTranslations(locale as string);
    const client = new QueryClient();

    // Resolve appContext
    const [staticData] = await Promise.all([getStaticAppContext({locale})]);
    const appContext: AppContextData = {
        ...staticData,
        // application specific context can go here
    };

    return {
        props: {
            appContext,
            dehydratedState: dehydrate(client),
            locale,
            pageKey: 'ub_request_demo',
            renderMode: RENDER_MODES.ISR as keyof typeof RENDER_MODES,
            translations,
        },
        revalidate: FOUR_HOURS,
    };
});

export default function DemoFormPage() {
    return <DemoFormFeature />;
}

DemoFormPage.getLayout = DemoFormFeature.getLayout;
